import React, { useContext, useState, useEffect } from 'react'
// APP CONTEXT
import { AppContext } from '../App'
// ROUTER
import { useNavigate, useLocation } from 'react-router-dom'
import useFirebase from '../firebase/useFirebase'

const PageFilterUserServeur = () => {
    const { user } = useContext(AppContext)
    const location = useLocation()
    let navigate = useNavigate() 
    // const { keyUid, tokenUser } = useParams()
    // const { readData, clients } = useFirebase()  
    const [keyUid, setKeyUid] = useState(localStorage.getItem('keyUid'))
    const [tokenUser, setTokenUser] = useState(localStorage.getItem('tokenUser'))
    const [montage, setMontage] = useState(false) 

    // ExponentPushToken[I88p4GCSIKKuXlYNBP7sQE]
    // https://naughty-rosalind-cbf8d6.netlify.app/homeUser/Z1NJJ5CuMoP28U12gxqQoR5NkvG2/I88p4GCSIKKuXlYNBP7sQE
    // https://localhost:3000/homeUser/Z1NJJ5CuMoP28U12gxqQoR5NkvG2/I88p4GCSIKKuXlYNBP7sQE

    // useEffect(() => {
    //     window.scrollTo(0, 0)
    //     localStorage.setItem('keyUid', keyUid) 
    //     localStorage.setItem('tokenUser', tokenUser)
    //     setMontage(false)
    //     console.log('HomeUsers useEffect ',tokenUser)
    // },[])

    // useEffect(() => {
    //     readData(keyUid) 
    // },[montage])

    if (keyUid === user.uid) {
        navigate('/homeServeur')
    }

    if (keyUid !== user.uid) {
        navigate('/homeUser/'+keyUid+'/'+tokenUser)
    }

    return ( 
        <div></div>
    )
}

export default PageFilterUserServeur